<template>
  <div class="classic-customer">
    <div class="left-content">
      <div class="main-title">典型客户</div>
      <h1 class="title">1000+</h1>
      <p class="subtitle">累计服务客户</p>
      <h2 class="number">100,000+</h2>
      <p class="description">业务支持机数量</p>
    </div>
    <div class="right-content">
      <div class="image-grid">
        <img
          v-for="logo in customerLogos"
          :key="logo.id"
          :src="logo.src"
          :alt="'客户logo ' + logo.id"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ClassicCustomer",
  data() {
    return {
      customerLogos: [
        { id: 1, src: require("@/assets/first/unit/01.svg") },
        { id: 3, src: require("@/assets/first/unit/03.svg") },
        { id: 4, src: require("@/assets/first/unit/04.svg") },
        { id: 5, src: require("@/assets/first/unit/05.svg") },
        { id: 6, src: require("@/assets/first/unit/06.svg") },
        { id: 7, src: require("@/assets/first/unit/07.svg") },
        { id: 8, src: require("@/assets/first/unit/08.svg") },
        { id: 9, src: require("@/assets/first/unit/09.svg") },
        { id: 10, src: require("@/assets/first/unit/10.svg") },
        { id: 11, src: require("@/assets/first/unit/11.svg") },
        { id: 12, src: require("@/assets/first/unit/12.svg") },
        { id: 13, src: require("@/assets/first/unit/13.svg") },
        { id: 14, src: require("@/assets/first/unit/14.svg") },
        { id: 15, src: require("@/assets/first/unit/15.svg") },
        { id: 16, src: require("@/assets/first/unit/16.svg") },
        { id: 17, src: require("@/assets/first/unit/17.svg") },
        { id: 18, src: require("@/assets/first/unit/18.svg") },
        { id: 19, src: require("@/assets/first/unit/19.svg") },
        { id: 20, src: require("@/assets/first/unit/20.svg") },
        { id: 21, src: require("@/assets/first/unit/21.svg") },
        { id: 23, src: require("@/assets/first/unit/23.svg") },
        { id: 24, src: require("@/assets/first/unit/24.svg") },
        { id: 25, src: require("@/assets/first/unit/25.svg") },
        { id: 26, src: require("@/assets/first/unit/26.svg") },
        { id: 27, src: require("@/assets/first/unit/27.svg") },
        { id: 28, src: require("@/assets/first/unit/28.svg") },
        { id: 30, src: require("@/assets/first/unit/30.svg") },
        { id: 32, src: require("@/assets/first/unit/32.svg") },
      ],
    };
  },
};
</script>

<style scoped>
.classic-customer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0 0 90px;
  /* padding: 0 8%; */
  max-width: 1900px;
}

.left-content {
  flex: 1;
  margin: 0 auto;
  text-align: left;
  max-width: 500px;
  position: relative;
  /* padding: 2rem 0; */
}

.right-content {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  /* padding: 2rem; */
}

.image-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 0;
  /* width: 100%; */
  max-width: 1400px;
}

.image-grid img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.image-grid img:hover {
  transform: scale(1.5);
  z-index: 1;
}

.main-title {
  font-size: clamp(24px, 3vw, 36px);
  font-family: Microsoft YaHei, Microsoft YaHei-700;
  font-weight: 700;
  text-align: left;
  color: #2c3239;
  line-height: 1;
  margin-bottom: 2rem;
}

.title {
  font-size: clamp(32px, 4vw, 48px);
  font-family: DIN, DIN-700;
  font-weight: 700;
  text-align: left;
  color: #0b5cfe;
  line-height: 1;
  margin-bottom: 1rem;
}

.subtitle {
  font-size: clamp(14px, 1.5vw, 18px);
  font-family: Microsoft YaHei, Microsoft YaHei-400;
  font-weight: 400;
  text-align: left;
  color: #5f656c;
  line-height: 1.5;
  letter-spacing: 0.09px;
  margin-bottom: 3rem;
}

.number {
  font-size: clamp(32px, 4vw, 48px);
  font-family: DIN, DIN-700;
  font-weight: 700;
  text-align: left;
  color: #0b5cfe;
  line-height: 1;
  margin-bottom: 1rem;
}

.description {
  font-size: clamp(14px, 1.5vw, 18px);
  font-family: Microsoft YaHei, Microsoft YaHei-400;
  font-weight: 400;
  text-align: left;
  color: #5f656c;
  line-height: 1.5;
  letter-spacing: 0.09px;
}

/* @media screen and (max-width: 768px) {
  .classic-customer {
    flex-direction: column;
    padding: 2rem 5%;
  }

  .left-content {
    text-align: center;
    margin-bottom: 2rem;
  }

  .right-content {
    width: 100%;
  }

  .image-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }
} */
</style>
